var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2674 0H1.35086C0.608 0 0 0.607429 0 1.35086V18.6486C0 19.392 0.608 20 1.35086 20H10.2674C11.0103 20 11.6183 19.3931 11.6183 18.6491V1.35086C11.6183 0.607429 11.0103 0 10.2674 0ZM4.38286 0.973714H7.23543C7.32572 0.973714 7.39886 1.04686 7.39886 1.13771C7.39886 1.228 7.32572 1.30114 7.23543 1.30114H4.38286C4.29257 1.30114 4.21943 1.228 4.21943 1.13771C4.21943 1.04686 4.29257 0.973714 4.38286 0.973714ZM5.80914 19.3246C5.436 19.3246 5.13372 19.0223 5.13372 18.6486C5.13372 18.2749 5.436 17.9731 5.80914 17.9731C6.18229 17.9731 6.48457 18.2749 6.48457 18.6486C6.48457 19.0223 6.18229 19.3246 5.80914 19.3246ZM10.6783 17.5H0.94V2.14229H10.6783V17.5Z",
    fill: "#6D6D0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobileIcon.93901995b20a9be13b6eae5c7497f3a6.svg";
export { ForwardRef as ReactComponent };